import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Locale } from '@/lib/i18n/config'

interface LocaleState {
  locale: Locale
  setLocale: (locale: Locale) => void
}

export const useLocaleStore = create<LocaleState>()(
  persist(
    (set) => ({
      locale: 'es',
      setLocale: (locale) => {
        set({ locale })
        if (typeof document !== 'undefined') {
          document.cookie = `redy-locale=${locale};path=/;max-age=31536000;SameSite=Lax`
        }
      },
    }),
    { name: 'redy-locale' }
  )
)
